module.exports = __webpack_public_path__ + "img/logo.ce528d73.png";